import { styled } from '@mui/material';

import * as iconClose from '../../assets/icons/icon_close_gray.svg';

interface Props {
  dataE2E?: string;
  dataPendo?: string;
  iconSvg?: string;
  onClose: (evt?: React.MouseEvent<HTMLElement>) => void;
}

const CloseImg = styled('img')`
  cursor: pointer;
`;

export const CloseIcon = (props: Props) => {
  const { dataE2E, dataPendo, iconSvg, onClose } = props;
  return (
    <CloseImg
      alt="close"
      data-e2e={dataE2E}
      data-pendo={dataPendo}
      onClick={onClose}
      src={iconSvg ? iconSvg : iconClose}
    />
  );
};
